// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Header from '../Header.jsx';
import PatientSidebarInfo from './PatientSidebarInfo.jsx';
import PatientSidebarMenu from './PatientSidebarMenu.jsx';
import UpdatesPage from './updates/UpdatesPage.jsx';
import NewDiagnosisPage from './problem/NewDiagnosisPage.jsx';
import InformationHistoryPage from './informationHistory/InformationHistoryPage.jsx';
import CurrentProblemsPage from './problem/CurrentProblemsPage.jsx';
import ResolvedProblemsPage from './problem/ResolvedProblemsPage.jsx';
import TreatmentChartPage from './progressNote/TreatmentChartPage.jsx';
import ImmunizationsPage from './immunization/ImmunizationsPage.jsx';
import WellChildChecksPage from './wellChildCheck/WellChildChecksPage.jsx';
import TestingPage from './testing/TestingPage.jsx';
import GrowthChartsPage from './growthChart/GrowthChartsPage.jsx';
import VitalSignsPage from './vitals/VitalSignsPage.jsx';
import ExternalReportsPage from './externalReports/ExternalReportsPage.jsx';
import AggregatedNotesPage from './aggregatedNotes/AggregatedNotesPage.jsx';
import CounselingReportsPage from './counseling/CounselingReportsPage.jsx';

import { fetchPatientDataInitial } from '../../actions/patientActions';

import styles from '../../styles/PatientTemplate.scss';

type Props = {
  patient: Object,
  fetchPatientDataInitial: Function,
  match: Object,
  location: Object,
  activeAccount: Object,
}

class PatientTemplateComponent extends Component<Props> {
  contentRef: Object = React.createRef()

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.contentRef.current.scrollTo(0, 0);
    }
    const { patient } = this.props;
    if (patient && patient.data) {
      const { firstName, surname } = patient.data.generalInfo;
      document.title = `${firstName} ${surname} - HFA EHR`;
    }
  }

  componentDidMount() {
    this.props.fetchPatientDataInitial(this.props.match.params.id);
  }

  render() {
    const { match } = this.props;
    const counselors = ['robinz62', 'allen', 'ruth', 'rogerz', 'Trish Phiri', 'Mbongeni Hlophe'];
    const showCounseling = this.props.activeAccount && counselors.includes(this.props.activeAccount.username);
    return (
      <div className={styles.patientTemplate}>
        <Header />
        {this.props.patient.status === 'SUCCESS'
          && <div className={styles.pageContainer}>
            <div className={styles.sidebar}>
              <PatientSidebarInfo match={this.props.match} />
              <PatientSidebarMenu match={this.props.match} location={this.props.location} showCounseling={showCounseling} />
            </div>
            <div className={styles.content} ref={this.contentRef}>
              <Switch>
                <Route path={match.url} component={InformationHistoryPage} exact={true} />
                <Route path={`${match.url}/basicInformation`} component={InformationHistoryPage} />
                <Route path={`${match.url}/todos`} component={UpdatesPage} />
                <Route path={`${match.url}/newDiagnosis`} component={NewDiagnosisPage} />
                <Route path={`${match.url}/currentProblems`} component={CurrentProblemsPage} />
                <Route path={`${match.url}/resolvedProblems`} component={ResolvedProblemsPage} />
                <Route path={`${match.url}/progressNotes/:problemId`} component={TreatmentChartPage} />
                <Route path={`${match.url}/immunizations`} component={ImmunizationsPage} />
                <Route path={`${match.url}/wellChildChecks`} component={WellChildChecksPage} />
                <Route path={`${match.url}/testing`} component={TestingPage} />
                <Route path={`${match.url}/growthCharts`} component={GrowthChartsPage} />
                <Route path={`${match.url}/vitals`} component={VitalSignsPage} />
                <Route path={`${match.url}/externalReports`} component={ExternalReportsPage} />
                <Route path={`${match.url}/aggregatedNotes`} component={AggregatedNotesPage} />
                { showCounseling && <Route path={`${match.url}/counselingReports`} component={CounselingReportsPage} /> }
              </Switch>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  patient: state.patient,
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  fetchPatientDataInitial: patientId => dispatch(fetchPatientDataInitial(patientId)),
});

const PatientTemplate = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientTemplateComponent);

export default PatientTemplate;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/PatientTemplate.jsx